import React, { useState } from 'react';
import { Form, Input, Select } from 'antd';
import { useHistory, useParams } from 'react-router-dom';

import InlineAlert from '../../../components/common/InlineAlert';
import {
  DialogBody,
  DialogPrimaryButton,
  DialogFooter,
  DialogModal,
  DialogTitle,
  GhostButton,
} from '../../../components/common/DialogModal';
import { BookingForm } from '../../../components/NewBooking/BookingForm';
import { recordActivity } from '../../../API/workflow';
import { ROUTE_PREFIX_BOOKING, ROUTES } from '../../../constants/routes';
import { ACTIVITY_TYPE, STATUS } from '../../../constants';
import { scrollToFirstFormError } from '../../../utils/scrollUtils';

const { Option } = Select;
const { TextArea } = Input;
const { DEFAULT, PENDING, SUCCESS, FAILURE } = STATUS;

const POSTPONE_WEEK_OPTIONS = [1, 2, 3, 4];
const REASON_MAX_LENGTH = 1000;
const SERVER_ERROR_MESSAGE =
  'Something went wrong on server side, please try again';

const PostponeModal = ({ isPostponeModalOpen, togglePostponeModal }) => {
  const [form] = Form.useForm();
  const [status, setStatus] = useState(DEFAULT);
  const { workflowId } = useParams();
  const history = useHistory();

  const handleSubmit = async () => {
    let values;

    try {
      values = await form.validateFields();
    } catch (errorInfo) {
      scrollToFirstFormError(form, errorInfo);
      return;
    }

    setStatus(PENDING);

    const { status: resultStatus } = await recordActivity(workflowId, {
      name: ACTIVITY_TYPE.POSTPONE,
      ...values,
    });

    if (resultStatus !== SUCCESS) {
      setStatus(FAILURE);
      return;
    }

    togglePostponeModal(false);
    history.push(
      `${ROUTE_PREFIX_BOOKING}/${workflowId}${ROUTES.NOTIFICATION}?type=${ACTIVITY_TYPE.POSTPONE}`
    );
    setStatus(SUCCESS);
  };

  return (
    <DialogModal
      visible={isPostponeModalOpen}
      footer={null}
      width={520}
      onCancel={() => togglePostponeModal(false)}
    >
      <DialogBody>
        <DialogTitle>
          How long would you like to postpone your appointment?
        </DialogTitle>

        <BookingForm form={form} layout="vertical">
          <Form.Item
            name="postponeWeeks"
            label="Postpone Weeks"
            required
            rules={[{ required: true, message: 'Postpone Weeks is required' }]}
          >
            <Select placeholder="Select number of weeks">
              {POSTPONE_WEEK_OPTIONS.map((week) => (
                <Option value={week} key={week}>
                  {week} week{week > 1 ? 's' : ''}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="reason" label="Postpone Reasons">
            <TextArea
              rows={4}
              maxLength={REASON_MAX_LENGTH}
              showCount
              placeholder="Reason for postponing..."
            />
          </Form.Item>
        </BookingForm>

        {status === FAILURE && (
          <InlineAlert>{SERVER_ERROR_MESSAGE}</InlineAlert>
        )}
      </DialogBody>

      <DialogFooter>
        <GhostButton type="text" onClick={() => togglePostponeModal(false)}>
          Cancel
        </GhostButton>
        <DialogPrimaryButton
          onClick={handleSubmit}
          loading={status === PENDING}
        >
          Submit
        </DialogPrimaryButton>
      </DialogFooter>
    </DialogModal>
  );
};

export default PostponeModal;
